<template>
  <v-card class="filters-card mb-6" elevation="2">
    <v-card-title class="primary white--text mb-4">
      <v-icon left>mdi-filter</v-icon>
      Filtros de Reporte
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col
          v-for="(field, index) in filterFields"
          :key="'field-' + index"
          :class="field.class"
          cols="12"
          sm="6"
          md="4"
        >
          <v-autocomplete
            v-model="formData[field.model]"
            :items="field.items"
            :label="field.label"
            item-text="text"
            item-value="value"
            dense
            outlined
            clearable
            :loading="loading"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-for="dateField in dateFields"
          :key="dateField.model"
          cols="12"
          sm="6"
          md="4"
        >
          <v-menu
            v-model="dateField.menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="formData[dateField.model]"
                :label="dateField.label"
                persistent-hint
                prepend-icon="calendar_month"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
                :clearable="true"
                @click:clear="formData[dateField.model] = ''"
              />
            </template>
            <v-date-picker
              v-model="formData[dateField.model]"
              no-title
              @input="dateField.menu = false"
              :max="dateField.model === 'fecha1' ? formData.fecha2 : null"
              :min="dateField.model === 'fecha2' ? formData.fecha1 : null"
            />
          </v-menu>
        </v-col>
      </v-row>

      <v-row class="mt-2">
        <v-col cols="12" md="4" class="text-center">
          <v-btn
            color="primary"
            :loading="loading"
            @click="$emit('generate')"
            block
          >
            <v-icon left>view_timeline</v-icon>
            Generar Reporte
          </v-btn>
        </v-col>
        <v-col cols="12" md="4" class="text-center">
          <v-btn
            color="success"
            :loading="loading"
            @click="$emit('export-excel')"
            block
          >
            <v-icon left>table_view</v-icon>
            Exportar a Excel
          </v-btn>
        </v-col>
        <v-col cols="12" md="4" class="text-center">
          <v-btn
            color="error"
            :loading="loading"
            @click="$emit('export-pdf')"
            block
          >
            <v-icon left>picture_as_pdf</v-icon>
            Exportar a PDF
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ReportFilters",
  props: {
    formData: {
      type: Object,
      required: true,
    },
    filterFields: {
      type: Array,
      required: true,
    },
    dateFields: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.filters-card {
  border-top: 4px solid var(--v-primary-base);
}
</style>
